import * as React from 'react';
import { createComponent, ErrorType, errorRing, styled, } from '@workday/canvas-kit-react/common';
import { colors, borderRadius, inputColors, spaceNumbers, type, space, } from '@workday/canvas-kit-react/tokens';
import { caretDownSmallIcon } from '@workday/canvas-system-icons-web';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
const StyledSelect = styled('select')({
    ...type.levels.subtext.large,
    border: `1px solid ${inputColors.border}`,
    display: 'block',
    backgroundColor: inputColors.background,
    borderRadius: borderRadius.m,
    boxSizing: 'border-box',
    height: space.xl,
    minWidth: 280,
    transition: '0.2s box-shadow, 0.2s border-color',
    padding: spaceNumbers.xxs,
    margin: 0,
    MozAppearance: 'none',
    WebkitAppearance: 'none',
    '&::placeholder': {
        color: inputColors.placeholder,
    },
    '&:hover': {
        borderColor: inputColors.hoverBorder,
    },
    '&:focus:not([disabled])': {
        borderColor: inputColors.focusBorder,
        boxShadow: `inset 0 0 0 1px ${inputColors.focusBorder}`,
        outline: 'none',
    },
    '&:disabled': {
        backgroundColor: inputColors.disabled.background,
        borderColor: inputColors.disabled.border,
        color: inputColors.disabled.text,
        '&::placeholder': {
            color: inputColors.disabled.text,
        },
    },
}, ({ error }) => ({
    ...errorRing(error),
}), ({ grow }) => grow && {
    width: '100%',
});
const SelectDropdownIcon = styled(SystemIcon)({
    position: 'absolute',
    top: space.xxxs,
    right: space.xxxs,
    padding: space.xxxs,
    pointerEvents: 'none',
    '& path': {
        transition: '100ms fill',
    },
});
const SelectWrapper = styled('div')({
    position: 'relative',
}, ({ grow }) => ({
    display: grow ? 'block' : 'inline-block',
}), ({ disabled }) => ({
    '& span': {
        backgroundColor: disabled ? colors.soap100 : colors.frenchVanilla100,
    },
    '&:hover path': {
        fill: disabled ? undefined : colors.licorice500,
    },
}));
export const Select = createComponent('select')({
    displayName: 'Select',
    Component: ({ disabled = false, grow, children, ...elemProps }, ref, Element) => (React.createElement(SelectWrapper, { grow: grow, disabled: disabled },
        React.createElement(StyledSelect, Object.assign({ as: Element, disabled: disabled, grow: grow, ref: ref }, elemProps), children),
        React.createElement(SelectDropdownIcon, { icon: caretDownSmallIcon, color: disabled ? colors.licorice100 : colors.licorice200, colorHover: disabled ? colors.licorice100 : colors.licorice500 }))),
    subComponents: {
        ErrorType,
    },
});
